import $ from 'jquery';
import cookie from 'react-cookies';
import * as commmentsUtils from '../js/video_comments';
import * as chatUtils from '../js/live_chat';
import defualt_helnix_logo from '../../../assets/DVTools/images/logo.png';
import * as globalUtils from '../../Global/global_js';
var player_guid = "";
var video_player_design_for_page = "";
var video_player_design_for_div = "";
var player_design_info = [];
var logo_image_guid = "none";
var brand_logo = "";
var dv_product_id = 0;
var default_logo_image = "default_logo_img";
var logo_src = "";
var vortex_url = "";
var video_guid = "";
var comment_interval = null;
var chat_interval = null;
var homepage_link = "";
var is_watching = true;
var check_visitoe_timeout_interval = null;
var visitor_timeount_in_ms = null;

function check_user_activity_on_browser(t)
{
    $(document).mousemove(function (event)
    {
        reset_timer(t);
    });
}
export function reset_timer(t)
{
    if (visitor_timeount_in_ms !== null)
    {
        clearInterval(check_visitoe_timeout_interval);
        check_visitoe_timeout_interval =
            setInterval(function ()
            {
                show_timeout_modal(t);
            }, visitor_timeount_in_ms);
    }
}

// load data for admin settings section page and div
export function load_design(t, response)
{
    try
    {
        video_guid = t.state.videoData.videoGuid;
        if (response.player_design_info == undefined)
        {
            player_design_info = response;
        }
        else
        {
            player_design_info = response.player_design_info;
        }

        // will apply this settings to player page and to admin setting div

        if (player_design_info.length == 1)
        {
            $("#defualt_video_info").hide();
            player_guid = player_design_info[0].player_guid;
            // the default settings is the same video settings
            video_player_design_for_page = player_design_info[0];
            video_player_design_for_div = player_design_info[0];

        }
        else if (player_design_info.length == 2)// one of them is the default settings and the other is video settings
        {
            $("#defualt_video_info").show("slow");
            var video_default_guid = "";
            var video_default_type = "";
            var default_object = 0;
            var not_default_object = 1;
            if (player_design_info[1].set_as_default == "true" && player_design_info[0].set_as_default == "false")
            {
                default_object = 1;
                not_default_object = 0;
            }
            else
            {
                default_object = 0;
                not_default_object = 1;
            }

            if (player_design_info[not_default_object].ignor_default == "true")
            {
                player_guid = player_design_info[not_default_object].player_guid;
                video_player_design_for_page = player_design_info[not_default_object];
                video_player_design_for_div = player_design_info[not_default_object];
            }
            else
            {
                player_guid = player_design_info[not_default_object].player_guid;
                video_player_design_for_page = player_design_info[default_object];
                video_player_design_for_div = player_design_info[not_default_object];

                video_default_guid = player_design_info[default_object].video_guid;
                video_default_type = player_design_info[default_object].video_type;
            }
        }


        //$("#default_video_link").attr("href", "show?vg=" + video_default_guid + "&vt=" + video_default_type);

        // load data for admin settings section div
        load_player_design_for_div(t, video_player_design_for_div, response);

        // load data for admin settings section page
        load_player_design_for_page(t, video_player_design_for_page, response);


    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "load_design",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function load_player_design_for_div(t, video_settings,all_settings)
{
    try
    {
        if (video_settings != null)
        {
            var show_download = "";
            if (video_settings.show_download_btn == 'true' && all_settings.vod_is_youtube !=="True")
            {
                show_download = true;
            }
            else
            {
                show_download = false;
            }

            // show/ hide logo
            var show_logo = false;
            if (video_settings.show_logo == 'true')
            {
                show_logo = true;
            }

            // show/ hide chat
            var show_chat = false;
            if (video_settings.show_chat == 'true' && video_settings.video_type === "2")
            {
                show_chat = true;
                setInterval(
                    function ()
                    {
                        if (t.RightPartComponent)
                        {
                            t.RightPartComponent.loadChat();
                        }
                    }, 5000);
            }

            var show_references = false;

            if (video_settings.show_reference == 'true')
            {
                show_references = true;
            }

            var show_homepage = false;

            if (video_settings.show_homepage == 'true')
            {
                show_homepage = true;
                if (video_settings.homepage_link !== "a")
                {
                    homepage_link = video_settings.homepage_link;
                }
            }
            var show_bookmarks = false;
            if (video_settings.show_bookmarks == 'true' && video_settings.video_type === "1")
            {
                show_bookmarks = true;
            }
            // Comments checkbox
            var show_comments = false;

            if (video_settings.show_comments == 'true')
            {
                show_comments = true;
            }
            // facebook comments
            var show_fb_comments = false;
            if (video_settings.show_facebook_comments == 'true')
            {
                show_fb_comments = true;
            }

            var is_dark = false;
            if (video_settings.is_dark == true)
            {
                is_dark = true;
            }

            t.setState(prevState => ({
                videoDesignSettingDiv: {
                    ...prevState.videoDesignSettingDiv,
                    show_download: show_download,
                    show_logo: show_logo,
                    show_chat: show_chat,
                    show_references: show_references,
                    show_bookmarks: show_bookmarks,
                    show_comments: show_comments,
                    show_fb_comments: show_fb_comments,
                    show_homepage: show_homepage,
                    homepage_link: homepage_link,
                    player_guid: video_settings.player_guid,
                    logo_guid: logo_image_guid,
                    logo_src: logo_src,
                    is_dark: is_dark,
                }
            }));
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "load_player_design_for_div",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
// load page design with video settings
function load_player_design_for_page(t, video_settings, all_settings)
{
    try
    {
        if (video_settings != null)
        {
            var account_url = localStorage.getItem("get_account_server_url"); //localStorage.getItem("get_account_server_url");
            var x = window.location.hostname;
            var index = x.indexOf('.');
            var account_domain = x.substring(index + 1, x.length)
            if (t.state.customAccountInfo !== null)
            {
                if (all_settings.vod_img !== "")
                {
                    logo_src = localStorage.getItem("get_image_server_url") + "accounts_media/images/" + video_settings.account_guid + "/" + all_settings.vod_img;
                }
                else
                {
                    // load logo image
                    if (t.state.customAccountInfo.dv_product_id !== 39 && video_settings.logo_image === default_logo_image)
                    {
                        logo_src = defualt_helnix_logo;
                        logo_image_guid = "none";
                    }
                    else if (t.state.customAccountInfo.dv_product_id == 39 && video_settings.logo_image == default_logo_image && t.state.customAccountInfo.media_domain !== "")
                    {
                        logo_src = "";//t.state.customAccountInfo.brand_logo;
                        logo_image_guid = "none";
                    }
                    else if (t.state.customAccountInfo.dv_product_id == 39 && video_settings.logo_image == default_logo_image && t.state.customAccountInfo.media_domain === "")
                    {
                        logo_src = "";
                        logo_image_guid = "none";
                    }
                    else
                    {
                        logo_src = localStorage.getItem("get_image_server_url") + "accounts_media/images/" + video_settings.account_guid + "/" + video_settings.logo_image_name;
                        logo_image_guid = video_settings.logo_image;
                    }
                }
            }
            else
            {
                if (all_settings.vod_img !== "")
                {
                    logo_src = localStorage.getItem("get_image_server_url") + "accounts_media/images/" + video_settings.account_guid + "/" + all_settings.vod_img;
                }
                else
                {
                    if (video_settings.logo_image == default_logo_image)
                    {
                        logo_src = "";
                        logo_image_guid = "none";
                    }
                    else
                    {
                        logo_src = localStorage.getItem("get_image_server_url") + "accounts_media/images/" + video_settings.account_guid + "/" + video_settings.logo_image_name;
                        logo_image_guid = video_settings.logo_image;
                    }
                }

            }
            // show/ hide logo
            var show_logo = false;
            if (video_settings.show_logo == 'true')
            {
                show_logo = true;
            }



            var show_references = false;
            if (video_settings.show_reference == 'true' && video_player_design_for_div.video_type == 1)
            {
                show_references = true;
            }


            var show_download = false;
            if (video_settings.show_download_btn == 'true' && video_player_design_for_div.video_type == 1 && all_settings.vod_is_youtube !== "True")
            {

                show_download = true;
            }

            var show_homepage = false;
            if (video_settings.show_homepage == 'true')
            {
                if (video_settings.homepage_link !== "a")
                {
                    homepage_link = video_settings.homepage_link;
                }
                show_homepage = true;
            }

            var show_bookmarks = false;
            if (video_settings.show_bookmarks == 'true' && video_settings.video_type === "1")
            {
                show_bookmarks = true;
            }

            // Comments 
            var show_comments = false;
            if (video_settings.show_comments == 'true')
            {
                show_comments = true;
                commmentsUtils.get_video_comments(t);
                comment_interval = setInterval(function ()
                {
                    commmentsUtils.update_shown_comments(t);
                }, 120000);
            }

            // facebook comments
            var show_fb_comments = false;
            if (video_settings.show_facebook_comments == 'true')
            {
                show_fb_comments = true;
            }
            var is_dark = false;
            if (video_settings.is_dark == true)
            {
                is_dark = true;
            }
            var show_chat = false;
            if (video_settings.show_chat == 'true' && video_settings.video_type === "2")
            {
                show_chat = true;
                chat_interval = setInterval(function ()
                {
                    chatUtils.load_chat(t);
                }, 120000);
            }

            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    show_logo: show_logo,
                    logo_src: logo_src,
                    logo_image: logo_image_guid,
                    show_references: show_references,
                    show_bookmarks: show_bookmarks,
                    show_comments: show_comments,
                    show_fb_comments: show_fb_comments,
                    show_download: show_download,
                    show_homepage: show_homepage,
                    homepage_link: homepage_link,
                    is_dark: is_dark,
                    show_chat: show_chat,
                    hls_low_delay: video_settings.hls_low_delay,
                    visitor_timeout: video_settings.visitor_timeout
                },
                videoDesignSettingDiv: {
                    ...prevState.videoDesignSettingDiv,
                    logo_src: logo_src,
                    logo_image: logo_image_guid,
                    hls_low_delay: video_settings.hls_low_delay,
                    visitor_timeout: video_settings.visitor_timeout
                },
                loginToAccoiuntUrl: account_url,
                blocking: false,
            }), () =>
            {
                if (video_settings.visitor_timeout > 0)
                {
                    visitor_timeount_in_ms = (video_settings.visitor_timeout * 60 * 1000);
                    check_visitoe_timeout_interval =
                        setInterval(function ()
                        {
                            show_timeout_modal(t);
                        }, visitor_timeount_in_ms);
                    check_user_activity_on_browser(t);
                }
                if (show_chat === true)
                {
                    t.setState({ showSplitter: true, nestedPanes: [{ min: "50%", resizable: true, collapsible: false, }, { size: '15%', min: '10%', resizable: true, collapsible: false }], })

                    t.toggle("1");
                }
                else if (show_references === true && all_settings.vod_is_youtube!=="True")
                {
                    get_vod_references(t);
                    t.setState({ showSplitter: true, nestedPanes: [{ min: "50%", resizable: true, collapsible: false, }, { size: '15%', min: '10%', resizable: true, collapsible: false }], })
                    t.toggle("2");
                }
                else if (show_bookmarks === true && all_settings.vod_is_youtube !== "True")
                {
                    get_vod_bookmarks(t);
                    t.setState({
                        showSplitter:true,
                        nestedPanes: [{ min: "50%", resizable: true, collapsible: false, }, { size: '15%', min: '10%', resizable: true, collapsible: false }],
                    })
                    t.toggle("3");
                }
                else
                {
                    t.setState({
                        nestedPanes: [{ min: "100%", size: '100%', resizable: false, collapsible: false, },],
                        activeTab: "",
                        showSplitter:false,
                    })
                }

                if (show_comments === true)
                {
                    t.commentsToggle("1");
                }
                else if (show_fb_comments === true)
                {
                    t.commentsToggle("2");
                }
                else if (video_settings.account_guid === t.state.videoData.userGuid)
                {
                    t.commentsToggle("3");
                }
            })

        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "load_player_design_for_page",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);

    }
}
function show_timeout_modal(t)
{
    try
    {
        t.setState({ showStillWatchingAlert: true, is_watching: false }, () =>
        {
            is_watching = false;
            var closeSeconds = 14;
            var interval = setInterval(function ()
            {
                t.setState({ timerSecondes: closeSeconds }, () =>
                {
                    closeSeconds--;
                })
                if (closeSeconds < 0)
                {
                    clearInterval(interval);
                }
            }, 1000);
            setTimeout(function ()
            {

                if (t.state.is_watching == false)
                {
                    t.setState({ showStillWatchingAlert: false, showEndWatchingAlert: true, openDrawer: false }, () =>
                    {
                        clearInterval(check_visitoe_timeout_interval);
                        //clearInterval(check_vod_expiration_and_password);
                        if (t.PlayerItem !== undefined && t.PlayerItem !== null)
                        {
                            t.PlayerItem.onStopButtonClick();
                            t.PlayerItem.onDestroyPlayer();
                        }
                        //if (vortex)
                        //{
                        //    vortex.vortexplayer('pause');
                        //    vortex.vortexplayer('destroy');
                        //    vortex = null;
                        //}
                        //if (youtube_player)
                        //{
                        //    youtube_player.pauseVideo();
                        //}
                    })

                }
            }, 15000);
        })

    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "show_timeout_modal",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
export function show_still_watching_alert(t)
{
    var stillWatchingAlertTimer = parseInt(t.state.videoData.visitor_timeout) * 60;
    setTimeout(() =>
    {
        t.setState({ showStillWatchingAlert: true }, () =>
        {
            setTimeout(() =>
            {
                t.setState({ showStillWatchingAlert: false });
            }, 15000);
        });
    }, stillWatchingAlertTimer);



}
function get_vod_references(t)
{
    try
    {
        var url = localStorage.getItem("api_url") + "get_vod_references_by_vod_guid";
        var parameters = {
            vod_guid: video_guid
        };

        $.ajax({
            url: url,
            type: 'POST',
            data: parameters,
            async: false,
            dataType: "json",
            success: function (response)
            { get_vod_references_success(t, response) },
            error: get_vod_references_error

        });
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "get_vod_references",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}

function get_vod_references_success(t, response)
{
    try
    {
        if (response)
        {
            var all_ref = [];
            var ref_url = "";
            for (var i = 0; i < response.length; i++)
            {
                if (response[i].reference_url.indexOf("http") > -1)
                {
                    ref_url = response[i].reference_url;
                }
                else if (response[i].reference_url.indexOf("http") == -1)
                {
                    ref_url = localStorage.getItem("get_pdf_path")  + t.state.videoData.video_owner_account_guid + "/" + response[i].reference_url;
                }

                all_ref.push({
                    reference_title: response[i].reference_title,
                    reference_url: ref_url
                })
            }
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    video_references: all_ref,
                }
            }))

        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "get_vod_references_success",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function get_vod_references_error(ex)
{
    globalUtils.send_error_fun("playerPageDesignSettings.js",
        "get_vod_references_error",
        ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
}
export function get_vod_bookmarks(t)
{
    try
    {
        var url = localStorage.getItem("api_url") + "get_vod_bookmarks_by_vod_guid";
        var parameters = {
            vod_guid: video_guid
        };

        $.ajax({
            url: url,
            type: 'POST',
            data: parameters,
            async: false,
            dataType: "json",
            success: function (response)
            { get_vod_bookmarks_success(t, response) },
            error: get_vod_bookmarks_error

        });
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "get_vod_bookmarks",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function get_vod_bookmarks_success(t, response)
{
    try
    {
        if (response && response.length > 0)
        {
            response = response.sort(function (a, b)
            {
                var nameA = a.time.toUpperCase(); // ignore upper and lowercase
                var nameB = b.time.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB)
                {
                    return -1;
                }
                if (nameA > nameB)
                {
                    return 1;
                }

                // names must be equal
                return 0;
            });
            var title = "";
            var a;
            var all_bookmarks = [];
            for (var i = 0; i < response.length; i++)
            {
                title = response[i].title
                a = response[i].time.split(':'); // split it at the colons
                var seconds = 0;
                if (a.length > 2)
                {
                    seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
                }
                else
                {
                    seconds = (+a[0]) * 60 + (+a[1]);
                }
                all_bookmarks.push({
                    bookmark_title: response[i].title,
                    bookmark_second: seconds,
                })
            }
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    video_bookmarks: all_bookmarks,
                }
            }))
        }
        else
        {
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    video_bookmarks: [],
                }
            }))
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("playerPageDesignSettings.js",
            "get_vod_bookmarks_success",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function get_vod_bookmarks_error(ex)
{
    globalUtils.send_error_fun("playerPageDesignSettings.js",
        "get_vod_bookmarks_error",
        ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
}